export const getBackgroundColorGeometry = (options, dimension, template) => {
  const x = Number(options.X) || 0;
  const y = Number(options.Y) || 0;
  const width = Number(options.Width) || dimension[0];
  const height = Number(options.Height) || dimension[1];

  const coversTemplate = template?.width > 0 && template?.height > 0
    && x <= 0 && y <= 0
    && x + width >= template.width
    && y + height >= template.height;

  if (coversTemplate) {
    return { left: 0, top: 0, width: dimension[0], height: dimension[1] };
  }

  return {
    left: x - (dimension[2] || 0) + (dimension[4]?.x || 0),
    top: y - (dimension[3] || 0) + (dimension[4]?.y || 0),
    width,
    height,
  };
};
